import currencySwitcherService from './LoadServices/currencySwitcherService';

(function ($) {

  $(document).on('click', '.menu-item-has-children > a', function (e) {
    let mobile = window.matchMedia('(max-width: 991px)');

    if (!mobile.matches) {
      return;
    }

    let parentMenuItem = $(this).parent('.menu-item-has-children');

    if (!parentMenuItem.hasClass('dropdown-open')) {
      e.preventDefault();
      parentMenuItem.toggleClass('dropdown-open');
    }
  });

  $(window).scroll(function () {
    // Show button after 100px
    var showAfter = 100;
    if ($(this).scrollTop() > showAfter) {
      $('.back-to-top').fadeIn();
    } else {
      $('.back-to-top').fadeOut();
    }
  });

  //Click event to scroll to top
  $('.back-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 800);
    return false;
  });

  //Click event to reveal content
  $('.read-more').click(function () {
    const parent = $(this).closest('.description__content');
    const shortContent = parent.find('.short-description');
    const fullContent = parent.find('.full-description');

    fullContent.css('display', 'block');
    shortContent.hide();

    $(this).remove();
  });

  // $(window).bind('scroll', function() {
  //   var navHeight = $(window).height() - $(window).height();;
  //     if ($(window).scrollTop() > navHeight) {
  //         $('.header').addClass('on');
  //     } else {
  //         $('.header').removeClass('on');
  //   }
  // });

  $(document).ready(function () {

    $('.accordion-header').click(function () {
      $(this).toggleClass('active');
      $(this).next('.accordion-content').slideToggle('slow');
      $('.accordion-content').not($(this).next()).slideUp('slow');
      $('.accordion-header').not($(this)).removeClass('active');
    });

    $('.scroll-btn').click(function (e) {
      var target = $(this).attr('data-target');

      if ($(target).length === 0) {
        // Get the current URL components
        const protocol = window.location.protocol; // 'http:' or 'https:'
        const hostname = window.location.hostname; // 'www.example.com'
        const port = window.location.port;         // '8080' (if specified)

        // Construct the root URL
        let rootUrl = `${protocol}//${hostname}`;
        if (port) {
          rootUrl += `:${port}`;
        }

        // Append the desired path or parameters to the root URL
        const newPath = '/tour-options#alltour';
        const newUrl = rootUrl + newPath;

        // Redirect to the new URL
        window.location.href = newUrl;
      } else {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(target).offset().top
        }, 1000);
      }
    });
  });

  $(document).ready(function () {
    $('.menu-toggle').click(function () {
      $('nav').toggleClass('menu-open');
      $('body').toggleClass('hidden');
    });

  });

  $('a.page-scroll').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 120
        }, 900);
        return false;
      }
    }
  });

  function setCookie(cookieName, cookieValue, expirationDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }

  (() => {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.checkout-trigger');
      if (trigger == null || window.Ventrata == null) {
        return;
      }

      e.preventDefault();

      const productID = trigger.dataset.product;
      const optionID = trigger.dataset.option;

      let currency = getCookie('selected_currency');

      if (!currency) {
        currency = window.applicationOptions.selectedCurrency
          ? window.applicationOptions.selectedCurrency
          : 'USD';
      }

      if (!productID) {
        return;
      }

      const options = {
        productID: productID,
        optionID: optionID,
        currency: currency,
        env: 'live'
      };

      if (optionID) {
        options.optionID = optionID;
      }

      window.Ventrata(options);
    });
  })();

  const ON_LOAD_SERVICES = [
    currencySwitcherService,
  ];

  window.addEventListener('load', () => {
    ON_LOAD_SERVICES.forEach((service) => service());
  });


})(jQuery);
